import Link from 'next/link';
import ProfileAvatar from '../ProfileUser/ProfileAvatar';
import { creatorName } from '@/utils/helpers';

interface Props {
  username: string;
  avatarUrl: string;
  userHref: string;
  hideUsername?: boolean;
  /** Public name; the avatar still keys off `username`. */
  displayName?: string | null;
  /** Unverified creators render as their username. */
  isVerified?: boolean;
}

export const ToneCardUserStack = ({
  username,
  avatarUrl,
  userHref,
  hideUsername,
  displayName,
  isVerified,
}: Props) => {
  return (
    <Link
      href={userHref}
      className="hover:text-zinc-200 text-zinc-400 transition-colors duration-200"
    >
      <div className="flex flex-row gap-2 items-center">
        <div className="block">
          <ProfileAvatar username={username} avatarUrl={avatarUrl} ownProfile={false} size={32} />
        </div>
        <p
          className={`text-sm whitespace-nowrap overflow-hidden text-ellipsis ${hideUsername ? 'hidden' : ''}`}
        >
          {creatorName({ username, display_name: displayName, is_verified: isVerified })}
        </p>
      </div>
    </Link>
  );
};

export default function ToneCardUser({
  username,
  avatarUrl,
  userHref,
  hideUsername,
  displayName,
  isVerified,
}: Props) {
  return (
    <Link
      href={userHref}
      className="hover:text-zinc-200 text-zinc-400 transition-colors duration-200"
    >
      <div className="flex flex-row gap-2 items-center">
        <div className="hidden sm:block">
          <ProfileAvatar username={username} avatarUrl={avatarUrl} ownProfile={false} size={32} />
        </div>
        <div className="block sm:hidden">
          <ProfileAvatar username={username} avatarUrl={avatarUrl} ownProfile={false} size={24} />
        </div>
        <p
          className={`text-xs sm:text-sm whitespace-nowrap overflow-hidden text-ellipsis ${hideUsername ? 'hidden' : ''}`}
        >
          {creatorName({ username, display_name: displayName, is_verified: isVerified })}
        </p>
      </div>
    </Link>
  );
}
